export const menuTitle = { title: "PRODUCT GROUP", label: "Product Group" }
  